import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ArticleComponent } from './article/article.component'
import { ArticleResolver } from './article/article.resolver'
import type { FloListResponse, FloResponse } from '@flocasts/flosports30-types/dist/flo-rest-api/response'
import type { Article } from '@flocasts/flosports30-types/dist/entity'
import { ARTICLE_TAG } from './article/article-analytics.service'
import { ARTICLE_SLUG_ROUTE_PARAM } from './articles.utility'
import { ArticleListComponent } from './article-list/article-list.component'
import { ARTICLE_LIST_TAG } from './article-list/article-list-analytics.service'
import { pathMatcher } from '../shared/utility-functions/slug.utility'
import { CORE_ID_OR_OFP_ID_RULES } from '../shared/utility-functions/regex.utility'

export interface ArticleDetailRouteData {
  articleResponse: FloResponse<Article, {}>
}

export interface ArticleListRouteData {
  articleListResponse: FloListResponse<Article, {}>
}

const routes: Routes = [
  {
    path: '',
    component: ArticleListComponent,
    data: {
      shouldShowEventTicker: true,
      /**
       * This will both prevent automatic page calls and also allow the
       * analytics directive to work.
       *
       * @see outExcludedRoutes
       */
      segment: ARTICLE_LIST_TAG
    }
  },
  {
    matcher: url => pathMatcher(url, `${ARTICLE_SLUG_ROUTE_PARAM}`, CORE_ID_OR_OFP_ID_RULES),
    component: ArticleComponent,
    resolve: { articleResponse: ArticleResolver },
    data: {
      shouldShowEventTicker: true,
      /**
       * This will both prevent automatic page calls and also allow the
       * analytics directive to work.
       *
       * @see outExcludedRoutes
       */
      segment: ARTICLE_TAG
    }
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ArticlesRoutingModule {}
